const ONE_TAB_WITH_IMAGE_BLOCK_DATA = {
  withMainTitle: false,
  mainTitle: [
    {
      id: 1,
      text: 'Main',
      textMob: 'Main',
      secondText: 'Title',
      secondTextMob: 'Title',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#293241',
      colorMob: '#293241',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [{
        id: 1,
        isLeftLine: false,
        isRightLine: true,
        isTopLine: false,
        isBottomLine: false,
        color: '#293241',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#293241',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  secondTitle: [
    {
      id: 1,
      text: '',
      textMob: 'SECOND',
      secondText: 'SECOND Title',
      secondTextMob: 'Title',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: true,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#293241',
      colorMob: '#293241',
      isTextWithLine: true,
      isTextWithLineMob: true,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [{
        id: 1,
        isLeftLine: false,
        isRightLine: true,
        isTopLine: false,
        isBottomLine: false,
        color: '#293241',
        isLineWithSquare: true,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#293241',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
  ],
  description: '',
  descriptionMobile: '',
  imageSrc: '',
  imageSrcMobile: '',
  buttonText: '',
  buttonTextMobile: '',
  buttonLink: '',
  buttonFunc: () => {},
  withoutShadowImage: true,
  withSecondTitle: true,
};

export default ONE_TAB_WITH_IMAGE_BLOCK_DATA;
